import React from "react";
import { getColumnMonthData } from "../../../../../utils/annual-planner-helpers";
import {
  MilestoneCounter,
  MonthCard,
  NutritionTargets,
  PhaseCard,
  PhasesDescriptionBubbles,
  StatsCard,
  WeekOfRow,
} from "./";

export const MonthColumn = ({
  month,
  startingCalendarDay,
  selectedDaysState,
  setSelectedDaysState,
  modifiers,
  modifiersStyles,
  modifiersClassNames,
  phases,
  isTrainingCollapsed = false,
  nutritionPhases,
  nutritionPhasesAttachments,
  handleNutritionPhaseSelection,
  isNutritionCollapsed = false,
  phasesAttachments,
  handlePhaseSelection,
  phasesDescriptions,
  isNotesCollapsed = false,
  milestones,
  isMilestonesCollapsed = false,
  units,
  isStatsCollapsed = true,
  athleteStatsState,
  isAnnualPlanner = true,
  nutritionPlans = [],
  athleteVolumesState,
  selectedWeek,
  onSelectWeek,
}) => {
  // Getting the number of weeks we need to display in the curren month
  // Also the hidden days that belong to the last week containing the first days of the next month
  const [numberOfWeeks, hiddenDays] = getColumnMonthData(
    month,
    startingCalendarDay
  );

  return (
    <div role="month-column">
      {isAnnualPlanner ? (
        <React.Fragment>
          {/* PRD 7.7/7.8: weeks as columns, a single clickable "week-of" date
              header - not the real day-by-day calendar MonthCard renders for
              the nutrition plans page below. */}
          <WeekOfRow
            month={month}
            startingCalendarDay={startingCalendarDay}
            numberOfWeeks={numberOfWeeks}
            selectedWeek={selectedWeek}
            onSelectWeek={onSelectWeek}
          />
          {/* This card shows the training phases corresponding to the month -
              hidden when the Training Phase section is collapsed, in sync
              with PhaseRowHeader in CalendarView's headers row. */}
          {!isTrainingCollapsed && (
            <PhaseCard
              numberOfWeeks={numberOfWeeks}
              month={month}
              phases={phases}
              startingCalendarDay={startingCalendarDay}
              phasesAttachments={phasesAttachments}
              handlePhaseSelection={handlePhaseSelection}
            />
          )}
          {/* Same grid, nutrition track - independent collapse + own
              phasesAttachments/handlePhaseSelection (track="nutrition"). */}
          {!isNutritionCollapsed && (
            <PhaseCard
              numberOfWeeks={numberOfWeeks}
              month={month}
              phases={nutritionPhases}
              startingCalendarDay={startingCalendarDay}
              phasesAttachments={nutritionPhasesAttachments}
              handlePhaseSelection={handleNutritionPhaseSelection}
            />
          )}
          {/* Phases descriptions corresponding to each week of the month -
              hidden when the Notes section is collapsed. */}
          {!isNotesCollapsed && (
            <PhasesDescriptionBubbles
              numberOfWeeks={numberOfWeeks}
              month={month}
              startingCalendarDay={startingCalendarDay}
              phasesAttachments={phasesAttachments}
              phasesDescriptions={phasesDescriptions}
              onSelectWeek={onSelectWeek}
            />
          )}
          {!!milestones.length && !isMilestonesCollapsed && (
            // If there are milestones (events or dated goals) we show the
            // weekly countdown until each one
            <MilestoneCounter
              numberOfWeeks={numberOfWeeks}
              milestones={milestones}
              units={units}
              month={month}
              startingCalendarDay={startingCalendarDay}
            />
          )}
          {/* At the end we have the card with the athlete stats - hidden
              when Tracked Results is collapsed, in sync with
              AthleteStatsHeader in CalendarView's headers row. */}
          {!isStatsCollapsed && (
            <StatsCard
              month={month}
              startingCalendarDay={startingCalendarDay}
              numberOfWeeks={numberOfWeeks}
              athleteStatsState={athleteStatsState}
              athleteVolumesState={athleteVolumesState}
            />
          )}
        </React.Fragment>
      ) : (
        <React.Fragment>
          <MonthCard
            month={month}
            hiddenDays={hiddenDays}
            startingCalendarDay={startingCalendarDay}
            selectedDaysState={selectedDaysState}
            setSelectedDaysState={setSelectedDaysState}
            modifiers={modifiers}
            modifiersStyles={modifiersStyles}
            modifiersClassNames={modifiersClassNames}
          />
          <NutritionTargets
            month={month}
            startingCalendarDay={startingCalendarDay}
            numberOfWeeks={numberOfWeeks}
            nutritionPlans={nutritionPlans}
          />
          <NutritionTargets
            month={month}
            startingCalendarDay={startingCalendarDay}
            numberOfWeeks={numberOfWeeks}
            nutritionPlans={nutritionPlans}
            restDay={true}
          />
          <StatsCard
            month={month}
            startingCalendarDay={startingCalendarDay}
            numberOfWeeks={numberOfWeeks}
            athleteStatsState={athleteStatsState}
            isAnnualPlanner={isAnnualPlanner}
          />
        </React.Fragment>
      )}
    </div>
  );
};
